import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Typography, CircularProgress } from '@mui/material';
import placeholderItem from 'styles/assets/placeholder/placeholder.gif';
import { getWallet_v1 } from 'js/library/utils/API/getWallet_v1';
import { trackEventMatomoElementId } from 'js/library/utils/helpers';

import './productStyles.css';
import { useState } from 'react';
import { useEffect } from 'react';
export default function Products(props) {
  const [totalPoints, setTotalPoints] = useState(0);
  const { productList, downloadImageOnLoad } = props;
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setLoading(true);
    const uId = props.userInfo.uId;

    getWallet_v1(uId)
      .then((wallet) => {
        setTotalPoints(wallet.totalPoints);
        setLoading(false);
      })
      .catch((error) => {
        console.log('Error', error);
        setLoading(false);
      });
  }, [props.userInfo.uId]);

  return (
    <div>
      {productList === null ? (
        <div style={{ textAlign: 'center' }}>
          <CircularProgress style={{ padding: '150px 20px', boxSizing: 'content-box' }} />
        </div>
      ) : (
        <div>
          {productList.length > 0 ? (
            <div>
              {' '}
              {loading ? (
                <div style={{ textAlign: 'center' }}>
                  <CircularProgress size={20} />
                </div>
              ) : (
                <Typography
                  variant="subtitle2"
                  style={{
                    fontWeight: 'bold',
                    color: '#6E3296',
                    textAlign: 'center',
                    marginBottom: '20px',
                  }}
                >
                  <i>
                    Você tem: {totalPoints} {totalPoints > 1 ? 'pontos' : 'ponto'}{' '}
                  </i>
                </Typography>
              )}
              <div className="container-product">
                {productList.map((row, x) => {
                  return (
                    <section key={row.id} className="card-product">
                      <div>
                        <Link
                          onClick={() =>
                            trackEventMatomoElementId(
                              'Estabelecimento',
                              'tocar',
                              'listaDeProdutos',
                              row.id
                            )
                          }
                          to={{
                            pathname: '/oferta/',
                            search: '?id=' + row.id,
                            state: row,
                          }}
                          style={{
                            display: 'inherit',
                            textDecoration: 'none',
                          }}
                        >
                          <img
                            alt="promo"
                            className="img-radius"
                            width="100%"
                            src={
                              row.downloadedThumbnail === undefined
                                ? placeholderItem
                                : row.downloadedThumbnail
                            }
                            onLoad={() => downloadImageOnLoad('productList', x)}
                          />
                        </Link>
                      </div>

                      <div className="item-card">
                        <Typography color="primary" variant="h6">
                          {row.establishmentName}
                        </Typography>
                        <Typography variant="h6" style={{ color: 'black', fontWeight: 'bolder' }}>
                          <i>{row.title}</i>
                        </Typography>
                        <Typography
                          color="secondary"
                          className="limit-text"
                          variant="caption"
                          style={{ whiteSpace: 'pre-line' }}
                        >
                          {row.description}
                        </Typography>
                        <Typography
                          style={{
                            color: 'black',
                            fontWeight: 'bold',
                            marginTop: '20px',
                          }}
                          color="secondary"
                          className="limit-text"
                          variant="caption"
                        >
                          {row.cost ? row.cost + 'pts' : null}
                        </Typography>
                      </div>
                    </section>
                  );
                })}
              </div>
            </div>
          ) : (
            <Typography
              style={{
                textAlign: 'center',
                fontSize: '20px',
                color: '#8B8B8B',
              }}
              color="secondary"
              className="limit-text"
              variant="caption"
            >
              {t('general.establishment_without_products')}
            </Typography>
          )}
        </div>
      )}
    </div>
  );
}
